<footer class="footer">
  <div class="mx-auto max-w-7xl py-10 px-6">
    <div class="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
      <p class="text-xs colorCopyright">
        {{ 'FOOTER.COPYRIGHT' | translate }}
      </p>

      @if (isDevOrQaEnviroment()) {
        <ul class="footer-links-list">
          <li>
            <a routerLink="/about" class="footer-link">
              {{ 'FOOTER.ABOUT' | translate }}
            </a>
          </li>
          <li>
            <a routerLink="/terms" class="footer-link">
              {{ 'FOOTER.TERMS' | translate }}
            </a>
          </li>
          <li>
            <a routerLink="/privacy" class="footer-link">
              {{ 'FOOTER.PRIVACY' | translate }}
            </a>
          </li>
        </ul>
      }
    </div>
  </div>
</footer>
